import config from '../../config';

const handleCreateSubscriptionError = e => {
    if (e?.code === 'planFeaturesAreAlreadyProvided') {
        if (window.confirm(e.message)) {
            window.location.href = `${config.platformUrl}/sign-in`;
        }
    } else {
        alert(e.message || 'Failed create subscription');
    }
};

export {
    handleCreateSubscriptionError
};
